import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { HomePageComponent } from "./pages/home-page/home-page.component";
import { LoginPageComponent } from "./pages/login-page/login-page.component";
import { ProjectLayoutComponent } from "./pages/project-layout/project-layout.component";
import { ProjectResolver } from "./services/project-resolver.service";
import { LanguageResolver } from "./services/language-resolver";
import { RedirectToLanguageGuard } from "./guards/RedirectToLanguageGuard";
import { TermsPageComponent } from "./pages/terms-page/terms-page.component";
import { AtlasPageComponent } from "./pages/atlas-page/atlas-page.component";
import { DataPageComponent } from "./pages/data-page/data-page.component";

export const routes: Routes = [
  {
    path: ":language",
    resolve: {
      language: LanguageResolver,
    },
    children: [
      // { path: '', pathMatch: 'full', redirectTo: 'projects/atlas/landline' },
      {
        path: "",
        component: HomePageComponent,
        pathMatch: "full",
      },
      {
        path: "atlas",
        component: AtlasPageComponent,
      },
      {
        path: "data",
        component: DataPageComponent,
      },
      { path: "login", component: LoginPageComponent },
      {
        path: "projects",
        component: ProjectLayoutComponent,
        runGuardsAndResolvers: "always",
        // canActivate: [AuthenticatedGuard],
        resolve: {
          datasource: ProjectResolver,
        },
        children: [
          // { path: 'crowdsourcing', component: CrowdsourcingPageComponent },
          {
            path: "atlas",
            loadChildren: () => import("./atlas/atlas.module").then((m) => m.AtlasModule),
          },
          {
            path: "data",
            loadChildren: () => import("./data/data.module").then((m) => m.DataModule),
          },
          // {path: 'barometer', component: BarometerPageComponent},
        ],
      },
      { path: "terms", component: TermsPageComponent },
      // { path: 'applications', component: ApplicationsPageComponent },
    ],
  },
  { path: "**", canActivate: [RedirectToLanguageGuard], children: [] },
];

const config: ExtraOptions = {
  useHash: false,
  enableTracing: false,
  scrollPositionRestoration: "top",
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
